<template>
  <label
    :for="id"
    class="form__input-label"
  >
    <span
      v-if="!labelHidden"
      :class="['form__input-label-text', { 'form__input-label-text--required': required }]"
    >
      {{ label }}
    </span>
    <span
      ref="addressWrapper"
      class="form__input-icon-wrapper">
      <input
        v-if="type !== 'textarea'"
        :id="id"
        :name="name"
        :value="value"
        :autocomplete="autocomplete"
        :class="['form__input', { 'form__input--error': hasError, 'form__input--success': isValid }]"
        :type="type"
        :maxlength="maxlength"
        :pattern="pattern"
        :placeholder="placeholder"
        v-on="$listeners"
      >
      <textarea
        v-if="type === 'textarea'"
        :id="id"
        :name="name"
        :value="value"
        :autocomplete="autocomplete"
        :class="['form__textarea', { 'form__textarea--error': hasError, 'form__textarea--success': isValid }]"
        :type="type"
        :maxlength="maxlength"
        :pattern="pattern"
        :placeholder="placeholder"
        rows="6"
        v-on="$listeners"
      />
      <svg
        v-if="isValid"
        width="32px"
        height="32px"
        viewBox="0 0 32 32"
        class="input__icon input__icon--checkmark">
        <use xlink:href="#checkmarkIcon" />
      </svg>
    </span>

    <span
      v-show="error && error.length"
      class="form__sublabel form__sublabel--error"
      v-html="error"
    />
    <span
      v-if="subLabel.length && !error"
      class="form__sublabel form__sublabel--info"
    >
      {{ subLabel }}
    </span>
  </label>
</template>

<script>
export default {
  name: "FieldText",
  props: {
    autocomplete: {
      type: String,
      default: ""
    },
    error: {
      type: [String, Boolean],
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    label: {
      required: true,
      type: String
    },
    labelHidden: {
      type: Boolean,
      default: false
    },
    maxlength: {
      type: String,
      default: ""
    },
    name: {
      required: true,
      type: String
    },
    pattern: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    subLabel: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    value: {
      type: String,
      default: ""
    },
    validateable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    hasError() {
      return this.validateable && !!this.error;
    },
    isValid() {
      return this.validateable && !this.hasError && this.value.length > 0;
    }
  }
};
</script>

<style lang="scss" scoped>
label {
  margin: 1rem 0;
}
.form__textarea {
  font-weight: 400;
  padding: 0.5rem;
}
</style>
